export default function initDebugToggle(){
  const q = new URLSearchParams(location.search).get('debug') || '';
  const on = q.split(',').map(s=>s.trim().toLowerCase()).includes('inc') || window.__portfolioDebug === true;
  window.__portfolioDebug = on;
  window.__pdbg = (lvl, ...m) => {
    if (!window.__portfolioDebug) return;
    (console[lvl] || console.log)('%c[inc]', 'color:#7b5cff;font-weight:600', ...m);
  };
}